import React, { Component } from 'react';


import DoughnutComponent from './../components/ChartDoughnutDashboard/DoughnutComponent'


//Actualizacion develop
class DoughnutDB extends Component {

  render() {
    const { data, colors, name, title, date } = this.props;
    
    return (
      <DoughnutComponent
        name={name}
        title={title}
        data={data}
        date={date}
        colors={colors}
        openDialog={this.props.openDialog}
        onClickGraphic={this.props.onClickGraphic}
        watchMenu={this.props.watchMenu}
        seeMore={this.props.seeMore}
        width={this.props.width}
        height={this.props.height}
      />
    );
  }
}

export default DoughnutDB;